import { jsx as l } from "react/jsx-runtime";
import "react";
var t = (r) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 18V7.532c0-.657.171-1.275.489-1.808a3.512 3.512 0 0 1 1.354-1.29 3.486 3.486 0 0 1 1.814-.431c.617.026 1.224.22 1.774.58L31.406 15.05c.511.335.909.767 1.18 1.27.272.503.414 1.073.414 1.68a3.51 3.51 0 0 1-.414 1.68c-.27.504-.669.936-1.18 1.27L15.431 31.418a3.49 3.49 0 0 1-1.774.58 3.48 3.48 0 0 1-1.814-.432 3.496 3.496 0 0 1-1.354-1.29A3.509 3.509 0 0 1 10 28.468V18Z",
    clipRule: "evenodd"
  })
});
export {
  t as default
};
